module.exports = __webpack_public_path__ + "img/ساده .471d32da.jpg";